import { useEffect, useState } from 'react';
import { sprekersApi } from '../api';
import type { SpeakerProfile } from '../types';

/** Gedeelde sprekersprofielenlijst voor keuzelijsten (engagement aanmaken,
 * spreker (opnieuw) uitnodigen) doorheen de Sprekersmodule. */
export default function useSpeakerProfiles() {
  const [profiles, setProfiles] = useState<SpeakerProfile[]>([]);

  useEffect(() => {
    let active = true;
    sprekersApi
      .listProfiles()
      .then((data) => {
        if (active) setProfiles(data);
      })
      .catch(() => {
        if (active) setProfiles([]);
      });
    return () => {
      active = false;
    };
  }, []);

  return profiles;
}
